
import React from 'react';

export default class SocialFeed extends React.Component {

    render() {
        if (!this.props.symbol) {

            return;
        }
        return (
            <iframe className="ss-abs-pos-full" src={"../__stock-twits.html?symbol=" + this.props.symbol}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/social-feed.js